import { Component, OnInit } from '@angular/core';
import { PermissionEnum } from 'src/app/enums/permissions.enum';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(private authService: AuthService) {}

  userAvatarUrl = '';
  PermissionEnum = PermissionEnum;

  ngOnInit() {
    this.userAvatarUrl = this.authService.auth?.user?.avatar;
  }

  async logout() {
    await this.authService.logout();
  }
}
